import { EJsonQueryActionTypes } from '../../actions/jsonQuery';
import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { mapJsonQuery } from '../../mappers';

import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { TReduxActions } from '../../types/redux';
import { extractJsonQuery } from '../../utils/jsonQuery/extractJsonQuery';
import { mergeJsonQuery } from '../../utils/jsonQuery/mergeJsonQuery';

const defaultState: IJsonQuery = {};

export function nextJsonQueryReducer(state: IJsonQuery = defaultState, action: TReduxActions) {
  if (action.type === EPromosActionTypes.Success || action.type === EPaginationActionTypes.Success) {
    return mapJsonQuery(action.payload.jsonQuery);
  }

  if (action.type === EJsonQueryActionTypes.Merge) {
    return mergeJsonQuery(state, action.payload);
  }

  if (action.type === EJsonQueryActionTypes.Extract) {
    return extractJsonQuery(state, action.payload);
  }

  if (action.type === EJsonQueryActionTypes.Set) {
    return action.payload;
  }

  if (action.type === EJsonQueryActionTypes.Clear) {
    return mapJsonQuery({});
  }

  return state;
}
